import styles from "./PasswordInput.module.scss";
import { BaseInput, TInputProps } from "@/frontend/shared/ui/Input/BaseInput";
import { EyeIcon } from "@/frontend/shared/assets/icons/EyeIcon";
import { useState } from "react";
import { EyeClosedIcon } from "@/frontend/shared/assets/icons/EyeClosedIcon";
import clsx from "clsx";
import { Typography } from "../Typography";

export function PasswordInput({ type, className, value, ...rest }: TInputProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <BaseInput
      className={clsx(className, styles.container)}
      type={isPasswordVisible ? "text" : "password"}
      {...rest}
      value={value}
    >
      {!value ? null : (
        <div
          className={styles.passwordVisibilityIcon}
          onClick={() => setIsPasswordVisible((prev) => !prev)}
          title={isPasswordVisible ? "Hide password" : "Show password"}
        >
          {/* <EyeClosedIcon /> */}
          <Typography color="greyscale900" variant="label-4">
            {isPasswordVisible ? "Hide" : "Show"}
          </Typography>
        </div>
      )}
    </BaseInput>
  );
}
